import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';

import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useLegacyAxiosInstance,
} from './utils';

export const UpdateTaskFormSchema = z.object({ autoclose_tasks: z.boolean() });

export type UpdateTaskForm = z.infer<typeof UpdateTaskFormSchema>;

export async function updateTaskFn(axiosInstance: Promise<AxiosInstance>, data: UpdateTaskForm) {
  const instance = await axiosInstance;

  return instance.put('/company_configurations', UpdateTaskFormSchema.parse(data));
}

export function useUpdateTaskSettings() {
  const client = useQueryClient();
  const axiosInstance = useLegacyAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, UpdateTaskForm>({
    mutationFn: (data: UpdateTaskForm) => updateTaskFn(axiosInstance, data),
    onSuccess: _ => {
      client.invalidateQueries({ queryKey: ['taskSettings'] });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, UpdateTaskForm, 'updateTaskSetting'>(
    'updateTaskSetting',
    mutation,
  );
}
